import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'

import routes from '../../config/routes'

import componentIsFetching from '../../utils/components/componentIsFetching'

import SearchResult from '../SearchResult'
import SearchResultFlightInformation from '../SearchResultFlightInformation'

class SearchResults extends Component {
  state = {
    selectedFlights: {
      departure: null,
      return: null,
    },
  }

  constructor(props) {
    super(props)

    this.onAddPassenger = this.onAddPassenger.bind(this)
  }

  flightsHaveAllotmentsLeft(flights) {
    if (!Boolean(flights.length)) return false

    return Boolean(
      flights.filter(
        flight => flight.travelClassSeatCounts[0].availableSeatCount !== 0
      ).length
    )
  }

  flightHasAllotmentsLeft(flight) {
    return flight.travelClassSeatCounts.every(
      allotment => allotment.availableSeatCount > 0
    )
  }

  onAddPassenger(flightType, flight) {
    const newState = {
      ...this.state.selectedFlights,
      [flightType]: flight.flightId,
    }

    const departureFlights = this.props.results.find(res => res.order === 0)
    const hasDepartureFlight = this.flightsHaveAllotmentsLeft(
      departureFlights.items
    )

    const returnFlights = this.props.results.find(res => res.order === 1)
    const hasReturnFlight =
      returnFlights && this.flightsHaveAllotmentsLeft(returnFlights.items)

    let routeQuery =
      hasDepartureFlight && hasReturnFlight
        ? `departure=${newState.departure}&return=${newState.return}`
        : hasDepartureFlight
        ? `departure=${newState.departure}`
        : `departure=${newState.return}`

    const newBookingRoute = routes.newBooking

    if (hasDepartureFlight && hasReturnFlight) {
      if (newState.departure && newState.return) {
        routeQuery = `departure=${newState.departure}&return=${newState.return}`
        this.props.history.push(`${newBookingRoute}?${routeQuery}`)
      }
    } else {
      routeQuery = `departure=${flight.flightId}`
      this.props.history.push(`${newBookingRoute}?${routeQuery}`)
    }

    this.setState({
      selectedFlights: newState,
    })
  }

  render() {
    const { results, classes } = this.props

    return [...results]
      .sort((a, b) => a.order > b.order)
      .map(search => {
        return (
          <div className={classes.results} key={search.route}>
            <SearchResultFlightInformation {...search} />
            <SearchResult
              {...search}
              items={
                search.items && Boolean(search.items.length) ? search.items : []
              }
              selectedFlights={this.state.selectedFlights}
              onAddPassenger={item => {
                this.onAddPassenger(
                  search.order === 0 ? 'departure' : 'return',
                  item
                )
              }}
            />
          </div>
        )
      })
  }
}

SearchResults.propTypes = {
  results: PropTypes.array.isRequired,
  classes: PropTypes.shape({
    results: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
}

export default compose(
  withRouter,
  componentIsFetching
)(SearchResults)
